import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import { MetaPageEnum } from '~/core/declaration/declaration';
import { MetaTagService } from '~/core/utils/global-utils/global-utils';
import { ScreenUtils } from '../../core/utils/screen-utils/screen-utils';
@Component({
  selector: 'volvo-vehicle-offer-page',
  templateUrl: './vehicle-offer-page.component.html',
  styleUrls: ['./vehicle-offer-page.component.scss']
})
export class VehicleOfferPageComponent implements OnInit, AfterViewInit {
  mainImage: string = '/assets/pages/vehicleOffers/MainTruck.webp';
  imageObject: [
    {
      image: '/assets/pages/vehicleOffers/MainTruck.webp';
    }
  ];
  isTablet: boolean = false;
  path: string = '';
  currentRoute = '';
  constructor(private route: ActivatedRoute, private router: Router, private metaTagService: MetaTagService) {

  }
  ngOnInit(): void {
    if (ScreenUtils.isTablet()) this.isTablet = true;
    this.metaTagService.updateTagFor(MetaPageEnum.OurStock);
  }
  ngAfterViewInit(): void {
    this.scrollToElement();
  }
  scrollToElement(): void {
    if (this.path) {
      const el = document.getElementById(this.path);
      if (el) {
        el.scrollIntoView({ behavior: 'auto', inline: 'start' });
      }
      // Meta tag update logic for subpages can be handled here if needed
    }
  }
}
